import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-firma',
  templateUrl: './dialog-firma.component.html',
  styleUrls: ['./dialog-firma.component.css']
})
export class DialogFirmaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
